import { render, staticRenderFns } from "./TypeoperationsEdit_Headers.vue?vue&type=template&id=90e8a7ba&"
import script from "./TypeoperationsEdit_Headers.vue?vue&type=script&lang=js&"
export * from "./TypeoperationsEdit_Headers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports